import { HotspotsContainer } from './HotspotsContainer';
const FADE_DURATION = 0.4;
import * as THREE from 'three';

export default class HotspotsFadeInOutEffect {
	constructor() {
		this.hotspotContainer = HotspotsContainer.getInstance();
		this.clock = new THREE.Clock();
		this.worldPosVec = new THREE.Vector3();
	}

	tick = (proximitySourceObj) => {
		if (!proximitySourceObj || !proximitySourceObj.isObject3D) return;
		let proximitySourceObjWorldPos = new THREE.Vector3()
		proximitySourceObj.getWorldPosition(proximitySourceObjWorldPos);
		const currentTime = this.clock.getElapsedTime();

		const hps = this.hotspotContainer.getProximityHotspots();
		hps?.forEach((hotspot) => {
			if (!hotspot?.visualObject) return;
			const obj = hotspot.visualObject;
			const { enabled, threshold } = this.hotspotContainer.getEffectiveProximityConfig(hotspot);
			if (!enabled) return;

			// Initialize hotspot properties if not already set
			if (obj.initialized === undefined) {
				obj.initialized = true;
				obj.currentTargetOpacity = 0; // Start invisible
				if (obj.material) {
					obj.material.transparent = true; // Enable transparency
					obj.material.opacity = 0; // Initial opacity
				}
			}

			obj.getWorldPosition(this.worldPosVec);
			const distance =
				proximitySourceObjWorldPos.distanceTo(this.worldPosVec);

			// Determine desired target opacity based on distance
			const desiredTargetOpacity = distance < threshold ? 1 : 0;

			// Start a new fade if the target opacity changes
			if (desiredTargetOpacity !== obj.currentTargetOpacity) {
				obj.currentTargetOpacity = desiredTargetOpacity;
				obj.fadeStartTime = currentTime;
				obj.startOpacity = obj.material.opacity;
				obj.fadeDuration = FADE_DURATION;
			}

			// Update opacity if a fade is in progress
			if (obj.fadeStartTime !== undefined) {
				const elapsed = currentTime - obj.fadeStartTime;
				if (elapsed < obj.fadeDuration) {
					const t = elapsed / obj.fadeDuration; // Progress from 0 to 1
					obj.material.opacity =
						obj.startOpacity +
						(obj.currentTargetOpacity - obj.startOpacity) * t;
				} else {
					obj.material.opacity = 1;
					obj.material.opacity = obj.currentTargetOpacity; // Set final opacity
					delete obj.fadeStartTime; // Fade complete
				}
			}
		});
	};
}
